import config from "@/config"
export const domain = config.API_DOMAIN;
export const url = config.API_URL;
export const downloadUrl = config.API_URL1; // 跟随 NODE_ENV：dev=本地 build=服务器
